module.exports = __webpack_public_path__ + "img/山茱萸.2dc0a21c.jpg";